import { userRoleService } from '../../services/userRoleService';
import { getAssignmentRoleType } from './userFilterUtils';

/**
 * Aligne les affectations actives de l'utilisateur sur la liste de role_type souhaitée.
 * @param {string} userId
 * @param {string[]} desiredRoleTypes
 * @param {{ countryId?: string | null }} [options]
 */
export async function syncUserRoleTypes(userId, desiredRoleTypes, options = {}) {
  const uniqueDesired = [...new Set((desiredRoleTypes || []).filter(Boolean))];
  if (uniqueDesired.length === 0) {
    throw new Error('Au moins un rôle est requis');
  }

  const { countryId = null } = options;

  const [allRoles, assignments] = await Promise.all([
    userRoleService.getAllRoles(),
    userRoleService.getUserRoleAssignments(userId),
  ]);

  const activeAssignments = (assignments || []).filter((a) => a?.isActive !== false);
  const currentTypes = activeAssignments.map(getAssignmentRoleType).filter(Boolean);

  const toAdd = uniqueDesired.filter((t) => !currentTypes.includes(t));
  const toRemove = activeAssignments.filter((a) => {
    const t = getAssignmentRoleType(a);
    return t && !uniqueDesired.includes(t);
  });

  for (const assignment of toRemove) {
    await userRoleService.removeRoleAssignment(assignment.id);
  }

  for (const roleType of toAdd) {
    const roleMatch = allRoles?.find((r) => r?.roleType === roleType);
    if (!roleMatch?.id) continue;
    await userRoleService.assignRole({
      userId,
      roleId: roleMatch.id,
      countryId,
    });
  }
}

/** Options Select pour les rôles assignables (hors legacy `operators` inactif). */
export function mapAssignableRoleOptions(roles) {
  return (roles || [])
    .filter((r) => r?.roleType !== 'operators' && r?.isActive !== false)
    .map((role) => ({
      value: role.roleType,
      label: role.roleName,
    }));
}
